"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateStrCoordinates = exports.latLngToMapCoordinate = exports.extractFiletExtension = exports.strippHtmlString = exports.calculatePeriodInDays = exports.canRespond = exports.getValueByPath = exports.richTextDefaultValue = exports.nullifyEmptyStringProperties = exports.getFileSize = exports.isRichTextEmpty = exports.richTextContentToPlainText = exports.parseRichTextValue = exports.parseHTMLToJSON = exports.parsePlainTextToJSON = exports.isJsonStringArray = exports.isJsonString = void 0;
const moment_1 = __importDefault(require("moment"));
const draft_js_1 = require("draft-js");
const constants_1 = require("./constants");
const lodash_1 = require("lodash");
exports.isJsonString = (str) => {
    if (typeof str !== 'string') {
        return false;
    }
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};
exports.isJsonStringArray = (str) => {
    try {
        const json = JSON.parse(str);
        return Array.isArray(json);
    }
    catch (e) {
        return false;
    }
};
exports.parsePlainTextToJSON = (text) => {
    if (lodash_1.isString(text) && !exports.isJsonString(text)) {
        const contentState = draft_js_1.ContentState.createFromText(text);
        return JSON.stringify(draft_js_1.convertToRaw(draft_js_1.EditorState.createWithContent(contentState).getCurrentContent()));
    }
    else {
        return text;
    }
};
exports.parseHTMLToJSON = (text) => {
    if (lodash_1.isString(text) && !exports.isJsonString(text)) {
        const blocksFromHTML = draft_js_1.convertFromHTML(text);
        const contentState = draft_js_1.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
        return JSON.stringify(draft_js_1.convertToRaw(draft_js_1.EditorState.createWithContent(contentState).getCurrentContent()));
    }
    else {
        return text;
    }
};
const textToStateContent = (text) => {
    return JSON.stringify(draft_js_1.convertToRaw(draft_js_1.ContentState.createFromText(text.toString())));
};
exports.parseRichTextValue = (value) => {
    return exports.isJsonString(value) ? value : textToStateContent(value);
};
exports.richTextContentToPlainText = (value) => {
    var _a, _b;
    if (exports.isJsonString(value)) {
        return (_b = (_a = JSON.parse(value)) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.reduce((text, block, index) => {
            return text + `${block.text}${index ? '<br>' : ''}`;
        }, '');
    }
    else {
        return value || '';
    }
};
exports.isRichTextEmpty = (value) => {
    return !exports.richTextContentToPlainText(value);
};
exports.getFileSize = (fileSize) => {
    let sizeIndex = 0;
    let floatFileSize = parseFloat(fileSize);
    while (floatFileSize > 1024 && sizeIndex < constants_1.SIZE_CONVERTER.length) {
        floatFileSize /= 1024;
        sizeIndex++;
    }
    return `${floatFileSize.toFixed(2)} ${constants_1.SIZE_CONVERTER[sizeIndex]}`;
};
/** Recursively nullify empty string properties **/
exports.nullifyEmptyStringProperties = (obj) => {
    return Object.entries(obj).reduce((acc, cur) => {
        const key = cur[0];
        const value = cur[1];
        if (Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length) {
            return { ...acc, [key]: exports.nullifyEmptyStringProperties(value) };
        }
        return { ...acc, ...(value !== '' ? { [key]: value } : { [key]: null }) };
    }, {});
};
exports.richTextDefaultValue = () => JSON.stringify(draft_js_1.convertToRaw(draft_js_1.EditorState.createEmpty().getCurrentContent()));
/**
 * Query object by string path and returns value
 * @param obj the object to query
 * @param path the path of property to get
 * @returns the resolved value
 */
exports.getValueByPath = (obj, path) => path.split('.').reduce((acc, cur) => acc && acc[cur], obj);
exports.canRespond = (type, addressTo, organizations) => {
    if (type === constants_1.ReviewType.InformationRequest) {
        return (organizations === null || organizations === void 0 ? void 0 : organizations.some((o) => o.id === addressTo.id)) || false;
    }
    return true;
};
exports.calculatePeriodInDays = (firstDateInEpoch, secondDateInEpoch) => {
    const firstDate = moment_1.default.unix(firstDateInEpoch).startOf('day');
    const secondDate = moment_1.default.unix(secondDateInEpoch).startOf('day');
    return secondDate.diff(firstDate, 'days');
};
exports.strippHtmlString = (str) => str.replace(/(<([^>]+)>)/gi, '');
exports.extractFiletExtension = (fileName) => fileName.split('.').pop();
exports.latLngToMapCoordinate = (latlng) => {
    try {
        const parts = latlng.split(',');
        if (parts.length !== 2) {
            return undefined;
        }
        return {
            lat: parseFloat(parts[0].trim()),
            lng: parseFloat(parts[1].trim()),
        };
    }
    catch (_a) {
        return undefined;
    }
};
exports.validateStrCoordinates = (latlng) => {
    const mapCoordinate = exports.latLngToMapCoordinate(latlng);
    if (mapCoordinate) {
        const { lat, lng } = mapCoordinate;
        return !(isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180);
    }
    return false;
};
